module.exports = __webpack_public_path__ + "img/Porto Apartment - 81 of 85.a70e1b64.jpeg";